import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { applyTextType, Col, Container, mediaQuery, RddkTheme, Row } from 'db-npm-e4sc-rd-ui';
import * as React from 'react';
import styled from 'styled-components';
import { FieldChecker, Section } from '../../shared/components';
import imageScaler from '../../shared/utils/imageScaler';

const IMAGE_SIZE_LARGE = 700;
const IMAGE_SIZE_SMALL = 450;

export type ImageHeaderProps = {
  fields: any;
};

const ImageHeader: React.FC<ImageHeaderProps> = ({ fields = {} }) => {
  const imageSize = fields['Large Image']?.value === true ? IMAGE_SIZE_LARGE : IMAGE_SIZE_SMALL;

  return (
    <Section componentName="ImageHeader">
      <FieldChecker type="image" field={fields['Image']}>
        <OuterBox $imageSize={imageSize}>
          <CoverImage $imageSize={imageSize} backgroundImage={imageScaler(fields['Image']?.value?.src)} />
        </OuterBox>
      </FieldChecker>

      <TextContainer>
        <Row>
          <Col>
            <TextOverlayBox $imageSize={imageSize}>
              <FieldChecker type="text" field={fields['Label']}>
                <Label>
                  <Text field={fields['Label']} />
                </Label>
              </FieldChecker>

              <FieldChecker type="text" field={fields['Text']}>
                <RichText field={fields['Text']} />
              </FieldChecker>
            </TextOverlayBox>
          </Col>
        </Row>
      </TextContainer>
    </Section>
  );
};

export default ImageHeader;

const OuterBox = styled.div<{ $imageSize: number }>`
  height: 220px;
  ${mediaQuery.md} {
    height: ${(props) => props.$imageSize * 0.55}px;
  }
  ${mediaQuery.xl} {
    height: ${(props) => props.$imageSize * 0.7}px;
  }
`;

const CoverImage = styled.div<{ backgroundImage?: string; $imageSize: number }>`
  height: 290px;
  ${mediaQuery.md} {
    height: ${(props) => props.$imageSize * 0.75}px;
  }
  ${mediaQuery.xl} {
    height: ${(props) => props.$imageSize}px;
  }
  background-image: url(${(props) => props.backgroundImage});
  background-position: center;
  background-size: cover;
`;

const TextContainer = styled(Container)`
  ${mediaQuery.smDown} {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
`;

const TextOverlayBox = styled.div<{ $imageSize: number }>`
  min-height: ${290 - 220}px;
  padding-top: 48px;
  ${mediaQuery.md} {
    min-height: ${(props) => props.$imageSize * 0.75 - props.$imageSize * 0.55}px;
    padding-top: 56px;
  }
  ${mediaQuery.xl} {
    min-height: ${(props) => props.$imageSize - props.$imageSize * 0.7}px;
    padding-top: 72px;
  }
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
  background: #fff;
  border-radius: 10px 10px 0 0;

  h1,
  h2,
  h3 {
    margin: 0;
    ${applyTextType('h2')}
  }

  p {
    ${applyTextType('manchetBig')}
    color: ${RddkTheme.colors.grey90};
  }

  a {
    color: ${RddkTheme.colors.red50};
  }
`;

const Label = styled.div`
  display: inline-block;
  border-radius: 3px;
  padding: 7px 17px 6px 18px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: 0.8px;
  text-align: center;
  border: solid 2px ${RddkTheme.colors.grey90};
  margin-bottom: 40px;
`;
